import { makeDirection } from "helpers/makeDirection";
import { CUSTOMERS_TYPES } from "./customersTypes";
import { addLabelArray } from "helpers/addLabelArray";
import { orderArrayV2 } from "helpers/orderArray";

const {
  CATCH_AMAZON_CALL,
  STORE_CALL_ID,
  RESTORE_CALL_ID,
  STATIONS_AVAILABLE,
  REQUEST_CUSTOMER_DATA,
  GET_CUSTOMER_DATA,
  GET_CUSTOMERS,
  NEW_CUSTOMER_MODE,
  REGISTER_CUSTOMER,
  SET_NEW_CUSTOMER,
  SELECT_CUSTOMER,
  RESET_CUSTOMER,
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_INFO,
  SELECT_CUSTOMER_ACCOUNT,
  SELECT_ONLY_CUSTOMER_ACCOUNT,
  SELECT_VIEW,
  ADD_ACCOUNT_MODE,
  NEW_ACCOUNT,
  EDIT_ACCOUNT,
  GET_CUSTOMER_SERVICES,
  NEW_CUSTOMER_SERVICES,
  REQUEST_CUSTOMER_SERVICES,
  SET_SERVICE,
  SET_SCHEDULES,
  SET_CYCLE_DATE_SCHEDULES,
  SET_PRODUCTS,
  SELECT_CYCLE,
  GET_CUSTOMER_CYCLES,
  ADD_CYCLE_MODE,
  CREATE_CYCLE,
  EDIT_ACCOUNT_CYCLE,
  DELETE_ACCOUNT_CYCLE,
  CANCEL_CYCLE_MODE,
  GET_CUSTOMER_CONDITIONS,
  SET_CUSTOMER_CONDITIONS,
  ADD_CUSTOMER_CONDITION,
  EDIT_CUSTOMER_CONDITION,
  DELETE_CUSTOMER_CONDITION,
  GET_CUSTOMER_CONTRACTS,
  HIDE_COSTS,
  START_LOADING_CONTRACT,
  STOP_LOADING_CONTRACT,
  SET_AMAZON_CONNECT,
  CLEAN_CUSTOMERS,
  CLEAN_CUSTOMER_DETAIL,
  RESTORE_INITIAL,
  OPEN_AMAZON_CONNECT,
  SET_MAP_INFO,
  SET_STATIONS_BY_TOKEN,
  SET_ACCOUNT_CREDIT,
  SET_PUBLIC_ACCOUNT_PRODUCTS,
  SET_VALID_COUPON,
  SET_DISCOUNT_TYPE,
  ERROR_CUSTOMER_CREDIT,
} = CUSTOMERS_TYPES

const paymentMethods = [
  { value: 'CASH', label: 'Efectivo' },
  { value: 'CREDIT_CARD', label: 'Tarjeta de Crédito' },
  { value: 'DEBIT_CARD', label: 'Tarjeta de Débito' },
  { value: 'PAYMENT_LINK', label: 'Liga de Pago' },
  { value: 'TRANSFER', label: 'Transferencia' },
  { value: 'CREDIT', label: 'Crédito' },
]

const paymentStatus = [
  { value: 'PENDING', label: 'Pendiente' },
  { value: 'CONFIRMED', label: 'Confirmado' },
  { value: 'CANCELED', label: 'Cancelado' },
  { value: 'REJECTED', label: 'Rechazado' },
  { value: 'REFUNDED', label: 'Reembolsado' },
  { value: 'CHARGE_PENDING', label: 'Pendiente de Cargo' },
]

const supplyDates = [
  { value: 'tomorrow', label: 'Mañana' },
  { value: 'end_of_month', label: 'Fin de mes' },
  { value: 'half_of_month', label: 'Mediados de mes' }
]

const deliveryPreferences = [
  { value: 'weekdays', label: 'Entre semana' },
  { value: 'weekends', label: 'Fines de semana' },
  { value: 'everyday', label: 'Cualquier día' }
]

const initialState = {
  loadingCustomers: false,
  loadingCustomerData: false,
  loadingServices: false,
  loadingPdf: false,
  amazonConnectCall: {},
  accountInput: "",
  customers: [],
  paymentMethods,
  paymentStatus,
  allAccounts: [],
  isSelected: false,
  customer: {},
  appliedCoupon: {},
  stationsAvailable: [],
  customerServices: [],
  service: {},
  schedules: [],
  products: [],
  cyclesTypes: [],
  supplyDates,
  deliveryPreferences,
  cycle: {},
  customerConditions: {
    origin: "",
    agreedVolume: "",
    conditions: [],
  },
  contracts: [],
  viewCount: 0,
  account: {},
  newCustomerMode: true,
  editCustomer: false,
  addAccountMode: false,
  addMode: false,
  urlAmazonConnect: "",
  openAmazonConnect: false,
  myCallID: null,
  mapInfo: {},
  stopLoad: false,
  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },

  stationsByToken: [],
};

export const customersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REQUEST_CUSTOMER_DATA:
      return {
        ...state,
        loadingCustomerData: true,
      };

    case STORE_CALL_ID:
      return {
        ...state,
        myCallID: payload ? payload : null,
        stopLoad: true,
      };
    case RESTORE_CALL_ID:
      return {
        ...state,
        myCallID: null,
        amazonConnectCall: {},
        stopLoad: false,
      };
    case CATCH_AMAZON_CALL:
      return {
        ...state,
        amazonConnectCall: payload,
      }
    case SET_VALID_COUPON:
      return {
        ...state,
        appliedCoupon: payload
      }
    case GET_CUSTOMERS:
      const customersFullAddress = payload.customers.map((customer) => {
        return {
          ...customer,
          fullAddress: customer.address ? makeDirection(customer.address) : "",
        };
      });
      const accountsFullAddress = payload.accounts.map((account) => {
        return {
          ...account,
          fullAddress: account.address ? makeDirection(account.address) : "",
        };
      });

      return {
        ...state,
        loadingCustomers: false,
        customers: customersFullAddress,
        allAccounts: accountsFullAddress,
        accountInput: payload.accountInput,
      };
    case NEW_CUSTOMER_MODE:
      return {
        ...state,
        editCustomer: false,
        newCustomerMode: payload,
      };
    case REGISTER_CUSTOMER:
      return {
        ...state,
        newCustomerMode: false,
        customer: { ...payload, address: makeDirection(payload.address) },
      };
    case SET_NEW_CUSTOMER:
      return {
        ...state,
        customers: [
          { ...payload, fullAddress: makeDirection(payload.address) },
          ...state.customers,
        ],
        allAccounts: [
          {
            ...payload.accounts[0],
            isNew: payload.isNew,
            idCustomer: payload.idCustomer,
            fullAddress: makeDirection(payload.address),
            rfc: payload.rfc,
          },
          ...state.allAccounts,
        ],
      };
    case STATIONS_AVAILABLE:
      return {
        ...state,
        stationsAvailable: payload,
      };
    case GET_CUSTOMER_DATA:
      const address = payload.address ? makeDirection(payload.address) : "";
      const accountsAddress = payload.accounts.map((acc) => {
        return {
          ...acc,
          value: acc.id,
          label: acc.alias,
          fullAddress: payload.address ? makeDirection(payload.address) : "",
        };
      });
      const newPayload = {
        ...payload,
        accounts: accountsAddress,
        fullAddress: address,
      };
      return {
        ...state,
        loadingCustomerData: false,
        customer: newPayload,
      };

    case EDIT_CUSTOMER:
      return {
        ...state,
        addMode: false,
        editCustomer: payload,
        account: {},
        viewCount: 1,
      };
    case EDIT_CUSTOMER_INFO:
      const fullAddress = makeDirection(payload.address);
      const customerIdx = state?.customers?.findIndex(
        (customer) => payload?.id === customer?.id
      );
      const newEditedCustomers = state?.customers;
      const editedCustomer = {
        ...state.customer,
        ...payload,
        fullAddress,
      };

      if (customerIdx !== -1) newEditedCustomers[customerIdx] = editedCustomer;

      return {
        ...state,
        customers: newEditedCustomers,
        customer: editedCustomer,
      };
    case SELECT_CUSTOMER:
      return {
        ...state,
        customer: {
          ...payload,
          accounts: addLabelArray(payload.accounts, "alias"),
        },
        isSelected: true,
      };
    case RESET_CUSTOMER:
      return {
        ...initialState,
        customers: state.customers,
        allAccounts: state.allAccounts,
      };
    case SELECT_CUSTOMER_ACCOUNT:
      // const customer = state.customer.accounts.find(customer => customer.id === payload.id)

      return {
        ...state,
        account: payload.account,
        addMode: false,
        editCustomer: false,
        viewCount: payload.view,
      };
    case SELECT_ONLY_CUSTOMER_ACCOUNT:
      return {
        ...state,
        account: payload,
        addMode: false,
        editCustomer: false,
      };
    case SELECT_VIEW:
      return {
        ...state,
        viewCount: payload,
      };

    case ADD_ACCOUNT_MODE:
      return {
        ...state,
        account: {},
        addMode: true,
        editCustomer: false,
      };
    case NEW_ACCOUNT:
      return {
        ...state,
        addMode: false,
        customer: {
          ...state.customer,
          accounts: [...state.customer.accounts, { ...payload }],
        },
        account: { ...payload, label: payload.alias, value: payload.id }
      }
    case EDIT_ACCOUNT:
      const accountsEdited = [...state.customer.accounts];
      const accountIdx = accountsEdited.findIndex(
        (acc) => acc.id === payload.id
      );
      const { customer, ...payloadN } = payload;
      if (accountIdx !== -1) {
        accountsEdited[accountIdx] = {
          ...accountsEdited[accountIdx],
          ...payloadN,
          label: payloadN.alias,
        };
      }
      return {
        ...state,
        customer: {
          ...state.customer,
          accounts: accountsEdited,
        },
        account: accountsEdited[accountIdx],
      };
    case REQUEST_CUSTOMER_SERVICES:
      return {
        ...state,
        loadingServices: true,
      };
    case GET_CUSTOMER_SERVICES:
      return {
        ...state,
        loadingServices: false,
        // Se normaliza a [] para que la vista nunca haga .map sobre no-arreglo.
        customerServices: Array.isArray(payload) ? payload : [],
      };
    case SET_SERVICE:
      const service = state.customerServices.find(
        (serv) => serv.id === payload
      );
      return {
        ...state,
        service,
      };
    case NEW_CUSTOMER_SERVICES:
      const newServices = [
        ...(Array.isArray(payload) ? payload : []),
        ...(Array.isArray(state.customerServices) ? state.customerServices : []),
      ];
      return {
        ...state,
        loadingServices: false,
        customerServices: newServices,
      };
    case SET_SCHEDULES:
      const labelSchedules = (Array.isArray(payload) ? payload : []).map((sch) => {
        return {
          value: sch?.date,
          label: sch?.date,
          schedules: (Array.isArray(sch?.schedules) ? sch.schedules : []).map((sc) => {
            return {
              ...sc,
              // value: sc.id,
              value: `${sc.start} - ${sc.end}`,
              label: `${sc.start} - ${sc.end}`,
            };
          }),
        };
      });
      return {
        ...state,
        schedules: labelSchedules,
      };

    case SET_CYCLE_DATE_SCHEDULES:
      const labelSched = {
        value: payload.date,
        label: payload.date,
        schedules: payload.schedules.map((sc) => {
          return {
            ...sc,
            value: `${sc.start} - ${sc.end}`,
            label: `${sc.start} - ${sc.end}`,
          };
        }),
      };
      return {
        ...state,
        byDateSchedules: labelSched.schedules || [],
      };

    case SET_PRODUCTS:
      const labelProducts = payload.map((prod) => {
        return {
          ...prod,
          value: prod.id,
          label: prod.product,
        };
      });
      return {
        ...state,
        products: labelProducts,
      };

    case GET_CUSTOMER_CYCLES:
      const labelCycles = addLabelArray(payload, "type");
      return {
        ...state,
        cyclesTypes: labelCycles,
      };

    case SELECT_CYCLE:
      const cycle = {
        ...payload.cycle,
        alias: payload.alias,
        idAccount: payload.id,
        type: payload.type,
        editMode: true,
      };
      return {
        ...state,
        cycle: cycle,
      };
    case ADD_CYCLE_MODE:
      return {
        ...state,
        cycle: {},
        addCycleMode: true,
      };

    case CREATE_CYCLE:
      const { idAccount } = payload;
      const accountCreatedCycle = state.customer.accounts?.find(
        (acc) => acc.id === idAccount
      ) || state.allAccounts.find((acc) => acc.id === idAccount);

      if (!accountCreatedCycle) {
        console.error('Account not found for cycle creation:', idAccount);
        return state;
      }

      const updatedAccount = {
        ...accountCreatedCycle,
        cycles: [...(accountCreatedCycle.cycles || []), payload]
      };

      const updatedAccounts = state.allAccounts.map((acc) =>
        acc.id === idAccount ? updatedAccount : acc
      );

      const updatedCustomer = {
        ...state.customer,
        accounts: (state.customer.accounts || []).map((acc) =>
          acc.id === idAccount ? updatedAccount : acc
        ),
      };

      const updatedCustomers = state.customers.map((customer) =>
        customer.id === accountCreatedCycle.idCustomer ? updatedCustomer : customer
      );

      return {
        ...state,
        allAccounts: updatedAccounts,
        customer: updatedCustomer,
        customers: updatedCustomers,
        cycle: {},
        addCycleMode: false,
      };

    case EDIT_ACCOUNT_CYCLE:
      const { idAccount: idAccountEdit } = payload;
      const accountEditedCycle = state.customer.accounts?.find(
        (acc) => acc.id === idAccountEdit
      ) || state.allAccounts.find((acc) => acc.id === idAccountEdit);

      if (!accountEditedCycle) {
        console.error('Account not found for cycle edit:', idAccountEdit);
        return state;
      }

      const updatedAccountEdit = {
        ...accountEditedCycle,
        cycles: (accountEditedCycle.cycles || []).map(cycle =>
          cycle.id === payload.id ? payload : cycle
        )
      };

      const updatedAccountsEdit = state.allAccounts.map((acc) =>
        acc.id === idAccountEdit ? updatedAccountEdit : acc
      );

      const updatedCustomerEdit = {
        ...state.customer,
        accounts: (state.customer.accounts || []).map((acc) =>
          acc.id === idAccountEdit ? updatedAccountEdit : acc
        ),
      };

      const updatedCustomersEdit = state.customers.map((customer) =>
        customer.id === accountEditedCycle.idCustomer ? updatedCustomerEdit : customer
      );

      return {
        ...state,
        allAccounts: updatedAccountsEdit,
        customer: updatedCustomerEdit,
        customers: updatedCustomersEdit,
        cycle: {},
      };

    case CANCEL_CYCLE_MODE:
      return {
        ...state,
        addCycleMode: false,
      };
    case DELETE_ACCOUNT_CYCLE:
      const idAccountDel = payload.idAccount;
      const cycleIdDel = payload.cycleId;
      
      const accountDeletedCycle = state.customer.accounts?.find(
        (acc) => acc.id === idAccountDel
      ) || state.allAccounts.find((acc) => acc.id === idAccountDel);

      if (!accountDeletedCycle) {
        console.error('Account not found for cycle deletion:', idAccountDel);
        return state;
      }

      const updatedAccountDel = {
        ...accountDeletedCycle,
        cycles: (accountDeletedCycle.cycles || []).filter(cycle => cycle.id !== cycleIdDel)
      };

      const updatedAccountsDel = state.allAccounts.map((acc) =>
        acc.id === idAccountDel ? updatedAccountDel : acc
      );

      const updatedCustomerDel = {
        ...state.customer,
        accounts: (state.customer.accounts || []).map((acc) =>
          acc.id === idAccountDel ? updatedAccountDel : acc
        ),
      };

      const updatedCustomersDel = state.customers.map((customer) =>
        customer.id === accountDeletedCycle.idCustomer ? updatedCustomerDel : customer
      );

      return {
        ...state,
        allAccounts: updatedAccountsDel,
        customer: updatedCustomerDel,
        customers: updatedCustomersDel,
        cycle: {},
        addCycleMode: false,
      };

    case GET_CUSTOMER_CONDITIONS:
    case SET_CUSTOMER_CONDITIONS:
      return {
        ...state,
        customerConditions: payload,
      };

    case ADD_CUSTOMER_CONDITION:
      const newConditions = [
        ...state.customerConditions.conditions,
        ...payload.conditions,
      ];
      return {
        ...state,
        customerConditions: {
          ...state.customerConditions,
          origin: payload.origin,
          agreedVolume: payload.agreedVolume,
          conditions: newConditions,
        },
      };

    case EDIT_CUSTOMER_CONDITION:
      let editConditions = [...state.customerConditions.conditions];
      const idxCondition = editConditions.findIndex(
        (condition) => condition.id === payload.id
      );
      editConditions[idxCondition] = {
        ...editConditions[idxCondition],
        ...payload,
      };
      return {
        ...state,
        customerConditions: {
          ...state.customerConditions,
          conditions: editConditions,
        },
      };

    case DELETE_CUSTOMER_CONDITION:
      const conditionRemoved = state.customerConditions.conditions.filter(
        (cond) => cond.id !== payload
      );
      return {
        ...state,
        customerConditions: {
          ...state.customerConditions,
          conditions: conditionRemoved,
        },
      };

    case GET_CUSTOMER_CONTRACTS:
      const orderPayload = orderArrayV2(payload, "date", true);
      return {
        ...state,
        contracts: orderPayload,
      };

    case START_LOADING_CONTRACT:
      return {
        ...state,
        loadingPdf: true,
      };
    case STOP_LOADING_CONTRACT:
      return {
        ...state,
        loadingPdf: false,
      };
    case HIDE_COSTS:
      return {
        ...state,
        customer: {
          ...state.customer,
          hideCost: payload,
        },
      };

    case SET_AMAZON_CONNECT:
      return {
        ...state,
        urlAmazonConnect: payload,
      };
    case CLEAN_CUSTOMERS:
      return {
        ...state,
        customers: [],
        allAccounts: [],
      };
    // Limpia solo las listas que renderiza la vista de detalle de Cliente, para
    // que al montarla no queden residuos de una navegación anterior (CRM-3012).
    // No toca account/customer: el flujo de entrada a la vista los precarga.
    case CLEAN_CUSTOMER_DETAIL:
      return {
        ...state,
        customerServices: [],
        schedules: [],
        products: [],
        service: {},
        viewCount: 0,
      };
    case RESTORE_INITIAL:
      return {
        ...initialState,
      };
    case OPEN_AMAZON_CONNECT:
      return {
        ...state,
        openAmazonConnect:
          payload !== null ? payload : !state.openAmazonConnect,
      };

    case SET_MAP_INFO:
      return {
        ...state,
        mapInfo: payload,
      };

    case SET_STATIONS_BY_TOKEN:
      return {
        ...state,
        stationsByToken: payload,
      };

    case SET_ACCOUNT_CREDIT:
      let cAccounts = []
      if (payload.isTableView) {
        cAccounts = [...state.allAccounts]
      } else {
        cAccounts = [...state.customer.accounts];
      }
      const idxCA = cAccounts.findIndex((acc) => acc.id === payload.id);
      if (idxCA > -1) {
        cAccounts[idxCA] = {
          ...cAccounts[idxCA],
          creditAccounts: payload.response,
        };
      }

      if (payload.isTableView) {
        return {
          ...state,
          allAccounts: cAccounts,
        };
      }
      return {
        ...state,
        customer: {
          ...state.customer,
          accounts: cAccounts,
        },
        account: cAccounts[idxCA],
      };

    case ERROR_CUSTOMER_CREDIT:
      const creditSource = (payload.isTableView ? state.allAccounts : state.customer?.accounts) || [];
      const creditIdx = creditSource.findIndex((acc) => acc.id === payload.id);
      if (creditIdx === -1) return state;
      const creditAccounts = [...creditSource];
      creditAccounts[creditIdx] = { ...creditAccounts[creditIdx], errorCredit: true };
      return {
        ...state,
        ...(payload.isTableView
          ? { allAccounts: creditAccounts }
          : { customer: { ...state.customer, accounts: creditAccounts } }),
        account: creditAccounts[creditIdx],
      };
    case SET_PUBLIC_ACCOUNT_PRODUCTS:
      return {
        ...state,
        products: payload
      };
    case SET_DISCOUNT_TYPE:
      return {
        ...state,
        customer: {
          ...state.customer,
          discountType: payload
        }
      };
    default: 
      return state;
  }
};
